import theme from '@/constants/theme';

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: 16,
    marginTop: 16,
    flex: 1,
  },

  title: {
    fontWeight: 'bold',
    color: theme.colors.text.title,
  },

  indicatorContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  indicator: {
    color: theme.colors.text.caption,
  },
  indicatorContent: {
    color: theme.colors.text.body,
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 8,
  },
  benefitsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    color: theme.colors.text.body,
    listStyle: 'none',
  },
  benefitItem: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  benefitIcon: {
    display: 'flex',
    gap: 8,
    backgroundColor: theme.colors.background.secondary,
    padding: 8,
    borderRadius: 100,
  },
};

export default styles;
